import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

const TagInput = forwardRef(function TagInput({ value = [], onChange }, ref) {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    flush: () => {
      const lower = input.toLowerCase().trim();
      if (lower && !value.includes(lower)) {
        onChange([...value, lower]);
        setInput('');
        return [...value, lower];
      }
      return value;
    }
  }));

  useEffect(() => {
    fetch('/api/tags', { credentials: 'include' })
      .then(r => r.json())
      .then(data => setAllTags(Array.isArray(data) ? data.map(t => t.name) : []))
      .catch(() => {});
  }, []);

  const handleInput = (e) => {
    const val = e.target.value;
    setInput(val);
    if (val.trim()) {
      const filtered = allTags.filter(t =>
        t.includes(val.toLowerCase()) && !value.includes(t)
      );
      setSuggestions(filtered.slice(0, 6));
    } else {
      setSuggestions([]);
    }
  };

  const addTag = (tag) => {
    const lower = tag.toLowerCase().trim();
    if (lower && !value.includes(lower)) {
      onChange([...value, lower]);
    }
    setInput('');
    setSuggestions([]);
    inputRef.current?.focus();
  };

  const removeTag = (tag) => {
    onChange(value.filter(t => t !== tag));
  };

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ',') && input.trim()) {
      e.preventDefault();
      addTag(input.trim());
    }
    if (e.key === 'Backspace' && !input && value.length > 0) {
      removeTag(value[value.length - 1]);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className="tag-input-wrapper" onClick={() => inputRef.current?.focus()}>
        {value.map(tag => (
          <span key={tag} className="tag-chip">
            {tag}
            <button onClick={() => removeTag(tag)}>×</button>
          </span>
        ))}
        <input
          ref={inputRef}
          value={input}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder={value.length === 0 ? 'Type a tag and press Enter...' : ''}
        />
      </div>
      {suggestions.length > 0 && (
        <div className="tag-suggestions">
          {suggestions.map(s => (
            <button key={s} onClick={() => addTag(s)}>{s}</button>
          ))}
        </div>
      )}
    </div>
  );
});

export default TagInput;
